import FormIhrTierDto from "../../../../consumer/form/dto/FormIhrTierDto";
import HundDto from "../../../../consumer/form/dto/HundDto";
import FormHundBo from "./FormHundBo";
import { exportAnzahlHunde } from "./input/AnzahlHunde";
import { exportHundeVersicherbar } from "./input/HundeVersicherbar";

export default class FormBo {

    anzahlHunde: number;

    hunde: FormHundBo[];

    hundeVersicherbarBest: boolean;

    constructor() {
        this.anzahlHunde = 1;
        this.hundeVersicherbarBest = false;
        this.hunde = [new FormHundBo(), new FormHundBo(), new FormHundBo(), new FormHundBo(), new FormHundBo(), new FormHundBo()]
    }

    static exportFormulardaten(bo: FormBo) {
        const dto = new FormIhrTierDto();
        dto.anzahlHunde = exportAnzahlHunde(bo);
        dto.hunde = FormBo.exportHunde(bo);
        dto.hundeVersicherbarBest = exportHundeVersicherbar(bo, dto.hunde);
        return dto;
    }

    static exportHunde(bo: FormBo): HundDto[] {
        return bo.hunde.slice(0, bo.anzahlHunde).map(b => FormHundBo.exportViewAsDto(b));
    }

    static selectHund(formBo: FormBo, index: number) {
        if (index < 1) {
            throw Error(`Index ${index} not supported.`);
        }

        if (index > formBo.hunde.length) {
            throw Error(`Index ${index} out of range ${formBo.hunde.length}`);
        }
        return formBo.hunde[index - 1];;
    }
}